import React from "react";
import { Link, useLocation } from "react-router-dom";
import { WaziWordmark } from "./Logo";
import { Button } from "../components/ui/button";
import { Menu } from "lucide-react";

const Navbar = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = React.useState(false);
  if (pathname.startsWith("/admin")) return null;

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center">
          <WaziWordmark size={34} />
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-[#2D3748] font-medium">
          <Link to="/" data-testid="nav-home" className="hover:text-[#25D366] transition-colors">Home</Link>
          <Link to="/find-painter" data-testid="nav-find" className="hover:text-[#25D366] transition-colors">Find a painter</Link>
          <Link to="/get-started" data-testid="nav-get-started" className="hover:text-[#25D366] transition-colors">For painters</Link>
          <a href="#how" data-testid="nav-how" className="hover:text-[#25D366] transition-colors">How it works</a>
        </nav>
        <div className="hidden md:flex items-center gap-3">
          <Link to="/worker/login" data-testid="nav-worker-link" className="text-sm text-[#16A34A] hover:text-[#25D366] font-medium">Painter sign in</Link>
          <Link to="/get-started">
            <Button data-testid="nav-cta-btn" className="rounded-full bg-[#25D366] hover:bg-[#16A34A] text-white px-5 font-medium wazi-cta-glow">
              Start on WhatsApp
            </Button>
          </Link>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-lg hover:bg-[#F7FAFC]"
          aria-label="menu"
        >
          <Menu className="w-6 h-6 text-[#2D3748]" />
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E2E8F0] bg-white px-4 py-4 flex flex-col gap-3">
          <Link to="/" onClick={() => setOpen(false)} className="py-1">Home</Link>
          <Link to="/find-painter" onClick={() => setOpen(false)} className="py-1">Find a painter</Link>
          <Link to="/get-started" onClick={() => setOpen(false)} className="py-1">For painters</Link>
          <a href="#how" onClick={() => setOpen(false)} className="py-1">How it works</a>
          <Link to="/worker/login" onClick={() => setOpen(false)} className="py-1 text-sm text-[#16A34A]">Painter sign in</Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
